/**
 * Convert an array of records to a CSV string.
 *
 * @param records - Array of flat key-value records
 * @param columns - Optional column names and order; defaults to keys from first record
 * @returns CSV string with header row and data rows
 */
export function recordsToCsv(records: Record<string, unknown>[], columns?: string[]): string {
  if (records.length === 0) {
    return '';
  }

  const firstRecord = records[0];
  const headers = columns ?? (firstRecord ? Object.keys(firstRecord) : []);

  const headerRow = headers.map(escapeCsvField).join(',');
  const dataRows = records.map((record) => headers.map((key) => escapeCsvField(formatValue(record[key]))).join(','));

  return [headerRow, ...dataRows].join('\n');
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

function escapeCsvField(field: string): string {
  if (field.includes(',') || field.includes('"') || field.includes('\n')) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}
